(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-product-slider").forEach((root) => {
      // ====== 要素の取得 ======
      const mainEl = root.querySelector(".js-product-slider-main");
      const nextEl = root.querySelector(".js-product-slider-next");
      const prevEl = root.querySelector(".js-product-slider-prev");
      const thumbButtons = Array.from(root.querySelectorAll(".js-product-slider-thumb-button"));

      if (!mainEl) return;
      const mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        loop: true,
        allowTouchMove: true,
        navigation: { nextEl, prevEl },
      });

      const active_class = "-active";
      function updateThumbActiveByIndex(realIndex) {
        if (!thumbButtons.length) return;
        thumbButtons.forEach((btn) => {
          const raw = btn.getAttribute("data-slide-index");
          const idx = raw !== null ? parseInt(raw, 10) : NaN;
          btn.classList.toggle(active_class, Number.isFinite(idx) && idx === realIndex);
        });
      }

      function goToRealIndex(realIndex) {
        if (typeof mainSwiper.slideToLoop === "function") {
          mainSwiper.slideToLoop(realIndex);
        } else {
          mainSwiper.slideTo(realIndex);
        }
      }

      if (thumbButtons.length) {
        thumbButtons.forEach((btn) => {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            const raw = btn.getAttribute("data-slide-index");
            const target = raw !== null ? parseInt(raw, 10) : NaN;
            if (!Number.isFinite(target)) return;

            thumbButtons.forEach((b) => b.classList.remove(active_class));
            btn.classList.add(active_class);

            goToRealIndex(target);
          });
        });
      }
      mainSwiper.on("slideChange", () => {
        updateThumbActiveByIndex(mainSwiper.realIndex);
      });
      updateThumbActiveByIndex(mainSwiper.realIndex);
    });
  });
})();
